import { pluginId } from '../../../../pluginId';

export const ON_CHANGE = `${pluginId}/ON_CHANGE`;
export const SET_LOADED = `${pluginId}/SET_LOADED`;
